import React from 'react';
import { connect } from "react-redux";
import * as formsAction from "../../redux/actions/formsAction";
import Select from 'react-select';
import ControlService from '../../helper/controlservice';
import CreatableSelect from 'react-select/creatable';
import * as Actions from "../../redux/actions/loginAction";
import { settings } from '../../config/settings';
const uuidv4 = require('uuid/v4');

const groupStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
const groupBadgeStyles = {
  backgroundColor: '#EBECF0',
  borderRadius: '2em',
  color: '#172B4D',
  display: 'inline-block',
  fontSize: 12,
  fontWeight: 'normal',
  lineHeight: '1',
  minWidth: 1,
  padding: '0.16666666666667em 0.5em',
  textAlign: 'center',
};
function bindAction(dispatch) {
  return {
    resetData: (data, storekey) => dispatch(formsAction.resetFormData(data, storekey)),
    update: (key, value, storekey) => dispatch(formsAction.updateData(key, value, storekey)),
    updateEdit: (key, value) => dispatch(formsAction.updateEditData(key, value)),
    updateFilter: (key, value) => dispatch(formsAction.updateFilterData(key, value)),
    updateParent: (key, value) => dispatch(formsAction.updateParentCtrData(key, value)),
    resetModelPopup: (data) => dispatch(formsAction.resetModelPopup(data)),
    setModelFormId: (data) => dispatch(formsAction.setModelFormId(data)),
    setSidebarFormId: (data) => dispatch(formsAction.setSidebarFormId(data)),
    authSetToken: (data) => dispatch(Actions.authSetToken(data)),
    dataIsLoading: (bool) => dispatch(formsAction.dataIsLoading(bool)),
  };
}
const mapStateToProps = state => ({
  data: state.formDataReducer,
  filterdata: state.formDataReducer.filterdata,
  editformdata: state.formDataReducer.editformdata,
  parentctrdata: state.formDataReducer.parentctrdata,
  token: state.formLoginReducer.token,
  hasErrored: state.formDataReducer.hasErrored,
  isLoading: state.formDataReducer.isLoading,
  sidebarFormName: state.formDataReducer.sidebarFormName,
  isModelOpened: state.formDataReducer.isModelOpened,
});

class Dropdown extends React.PureComponent {

  state = {
    apiData: [],
    isApiCalling: false,
    visible: false,
    picked: null,
    groupedOptions: [],
    options: [],
    inputValue: "",
    modelFormData: null,
    isModelOpened: false,
    maximumselect: false,
    control: {},
    parentctrdata: null
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    var parentctrdata = nextProps.parentctrdata ? nextProps.parentctrdata[nextProps.formid + nextProps.control.key] : null;
    if (nextProps.control != prevState.control) {
      return {
        control: nextProps.control,
        parentctrdata: parentctrdata ? parentctrdata : null
      };
    } else if ((nextProps.control.Name === "BindingFieldList" || nextProps.control.Name === "ModelFieldList") && nextProps.control.isTableView) {
      var data = nextProps.data[nextProps.formid] ? nextProps.data[nextProps.formid] : {};
      let _data = data[nextProps.control.Name] ? data[nextProps.control.Name] : [];
      return {
        apiData: _data,
        parentctrdata: parentctrdata ? parentctrdata : null
      }
    } else if (nextProps.isModelOpened != prevState.isModelOpened) {
      return {
        isModelOpened: nextProps.isModelOpened,
        parentctrdata: parentctrdata ? parentctrdata : null
      }
    }
    else return {
      parentctrdata: parentctrdata ? parentctrdata : null
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { control, formid } = this.props;
    if ((control.Name === "BindingFieldList" || control.Name === "ModelFieldList") && control.isTableView) {
      if (JSON.stringify(prevState.apiData) != JSON.stringify(this.state.apiData)) {
        this.generateData(this.state.apiData);
      }
    }
    if (JSON.stringify(this.state.control) != JSON.stringify(prevState.control)) {
      var data = this.props.data[formid] ? this.props.data[formid] : {};
      let _data = control.isTableView && data[control.Name] ? data[control.Name] : control.optionlist ? control.optionlist : [];
      if ((control.databind && control.databind.toLowerCase() == "server data") || (!control.databind && _data.length == 0)) {
        if (control.isLazyLoad) {
          let val = data[control.textfield] ? data[control.textfield] : data[control.key] ? data[control.key] : null;
          if (val && typeof val == 'string') {
            this.setState({ inputValue: val }, () => this.ApiCall());
          }
        }
        else {
          this.ApiCall(this.state.parentctrdata);
        }
      }
      else {
        // this.setBindingwithothercontrols(control, this.props, true);

        if (control.outputtype == "number") {
          control.optionlist.forEach(item => {
            item.value = isNaN(parseInt(item.value)) ? item.value : parseInt(item.value);
          })
        }
        this.setState({
          apiData: _data,
          isApiCalling: false
        });
        this.generateData(_data);
      }
    }

    var nextData = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {};
    var currData = prevProps.data && prevProps.data[prevProps.formid] ? prevProps.data[prevProps.formid] : {};

    var parentctrdata = this.state.parentctrdata;
    if (parentctrdata && parentctrdata.id !== (prevState.parentctrdata ? prevState.parentctrdata.id : "")) {
      this.props.updateParent(this.props.formid + control.key, null);
      if ((this.state.control.databind && this.state.control.databind.toLowerCase() == "server data") || (!this.state.control.databind && this.state.control.optionlist.length == 0)) {
        // if (!this.state.isApiCalling) {
        this.ApiCall(parentctrdata, this.props.data[this.props.formid]);
        // }
      }
      else {
        this.setState({
          apiData: control.optionlist,
          isApiCalling: false
        });
        this.generateData(control.optionlist);
      }
    }
    if (nextData && currData && (Array.isArray(nextData[control.key]) && JSON.stringify(nextData[control.key]) != JSON.stringify(currData[control.key])) || (nextData[control.key] != currData[control.key])) {
      this.controlVaildationCheck(this.props);
      this.setBindingwithothercontrols(control, this.props, true);
      this.updatePageVarible(control, nextData, nextData[control.key]);

      if (!control.stopextranodesonload && this.state.apiData.length > 0 && control.selectiontype !== 'multi' && control.type !== 'multiselect') {
        this.storeExtraNodes(control, nextData[control.key]);
      }
    }

    if (this.state.isAdditemlinkClick && prevState.isModelOpened == true && this.state.isModelOpened == false && control.additemlink) {
      this.setState({
        isAdditemlinkClick: false,
      }, () => this.ApiCall(this.state.parentctrdata));
    }
  }
  async componentDidMount() {
    const { control, formid } = this.props;

    if (!control.stopbindingonload) {

      var data = this.props.data[formid] ? this.props.data[formid] : {};
      let _data = control.isTableView && data[control.Name] ? data[control.Name] : control.optionlist ? control.optionlist : [];

      // await this.setBindingwithothercontrols(control, this.props, false);
      this.controlVaildationCheck(this.props, true);
      debugger;
      if ((control.databind && control.databind.toLowerCase() == "server data") || (!control.databind && _data.length == 0)) {
        if (control.isLazyLoad) {
          let val = data[control.textfield] ? data[control.textfield] : data[control.key] ? data[control.key] : null;
          if (val && typeof val == 'string') {
            this.setState({ inputValue: val }, () => this.ApiCall(this.state.parentctrdata));
          }
        }
        else {
          this.ApiCall(this.state.parentctrdata);
        }
      }
      else {
        if (control.outputtype == "number") {
          control.optionlist.forEach(item => {
            item.value = isNaN(parseInt(item.value)) ? null : parseInt(item.value);
          })
        }
        this.setState({
          apiData: _data,
          isApiCalling: false
        });
        this.generateData(_data);
        this.controlVaildationCheck(this.props);
      }
    } else {
      this.controlVaildationCheck(this.props);
    }
  }
  ApiCall(refreshParam = null, data = null) {

    const { token } = this.props;

    var control = ControlService().deepcopy(this.props.control);
    debugger;
    var _data = data ? data : this.props.data[this.props.formid];
    this.setState({
      apiData: [],
      isApiCalling: true
    });
    let url = control.ResultApi ? control.ResultApi : control.apiurl;
    var ParamList = Array.isArray(control.ResultApiParam) && control.ResultApiParam.length > 0 ? control.ResultApiParam : control.ApiParam;
    var apiParam = {};
    if (Array.isArray(ParamList)) {
      ParamList.forEach(option => {
        if (option.key == control.search) {
          apiParam[option.key] = this.state.inputValue;
        } else if (option.isdatamodel) {
          apiParam[option.key] = _data[option.value];
        } else {
          apiParam[option.key] = option.value;
        }
      })
    }
    if (refreshParam) {
      if (_data && (_data[refreshParam.sourcecontrolkey] && (_data[refreshParam.sourcecontrolkey].length > 0) || !Number.isNaN(_data[refreshParam.sourcecontrolkey]))) {
        if (Array.isArray(_data[refreshParam.sourcecontrolkey])) {
          var parentModel = _data[refreshParam.sourcecontrolkey];
          apiParam[refreshParam.bindingfieldapi] = JSON.stringify(parentModel);
        } else if (_data[refreshParam.sourcecontrolkey]) {
          apiParam[refreshParam.bindingfieldapi] = _data[refreshParam.sourcecontrolkey];
        }
      }
      else {
        this.setState({
          apiData: [],
          isApiCalling: false
        }, () => this.generateData([]));
        return;
      }
    }
    if (url && token.loginMethod && (url.toLowerCase().includes('api/role/list') || url.toLowerCase().includes('application/getmenu') || url.toLowerCase().includes('appdata/list') || url.toLowerCase().includes('application/searchrow'))) {
      var _model = "";
      if (url.toLowerCase().includes('api/role/list')) {
        url = settings.ROLE_LIST_API;
      } else {
        if (url.toLowerCase().includes('appdata/list')) {
          control.method = settings.METHOD.GET;
          _model = settings.WORKBENCH.FORMLIST;
        }
        else if (url.toLowerCase().includes('application/getmenu')) {
          control.method = settings.METHOD.GET;
          _model = settings.WORKBENCH.MENU;
        }
        else {
          if (apiParam['type'] === 'emailconnections') {
            _model = settings.WORKBENCH.EMAILCONNECTIONS
          } else {
            _model = settings.WORKBENCH.DATACONNECTIONS
          }
          control.method = settings.METHOD.LIST;
        }

        control.model = _model;
        control.datasource = ControlService().loggedInDataSource(token)
      }
    }
    ControlService().ServiceRequest(url, apiParam, control, token, _data)
      .then(res => {
        var result = [];
        if (control.responsefield) {
          result = res && Array.isArray(res[control.responsefield]) ? res[control.responsefield] : [];
        } else {
          result = Array.isArray(res) ? res : [];
        }
        this.setState({
          apiData: result,
          isApiCalling: false
        }, () => {
          if (!control.stopextranodesonload && _data && result.length > 0 && control.selectiontype !== 'multi' && control.type !== 'multiselect') {
            this.storeExtraNodes(control, _data[control.key]);
          }
          this.generateData(result);
        });
        // this.setBindingwithothercontrols(control, this.props, this.props, true);
      })
      .catch(err => {

        this.setState({
          apiData: [],
          isApiCalling: false
        });
        this.generateData([]);
        // this.setBindingwithothercontrols(control, this.props, true);
        console.log(control.key + "~" + err.message);
      });
  }
  generateData(apiData) {
    const { control } = this.props;

    if (control.type == 'multiselect') {
      control.valuefield = control.textfield;
    }
    var groupedOptions = [];
    var options = {};
    if (control.groupby && Array.isArray(apiData)) {

      var __options = [];
      options = {};
      apiData.forEach((item) => {
        if (item[control.textfield] && item[control.valuefield]) {
          let arr = {}
          arr.label = item[control.textfield] ? item[control.textfield] : item["key"];
          arr.value = item[control.valuefield] ? item[control.valuefield] : item["value"];

          __options.push(arr);
        }
        if (!options[item[control.groupbyfield]]) {
          var _options = [];
          apiData.forEach((_item) => {
            if (item[control.groupbyfield] == _item[control.groupbyfield]) {
              let arr = {}
              arr.label = _item[control.textfield] ? _item[control.textfield] : _item["key"];
              arr.value = _item[control.valuefield] ? _item[control.valuefield] : _item["value"];
              _options.push(arr);
            }
          })
          options[item[control.groupbyfield]] = _options;
        }
      });
      Object.keys(options).forEach(key => {
        var arr = {}
        arr.label = key;
        arr.options = options[key];
        groupedOptions.push(arr);
      })
      this.setState({
        groupedOptions: groupedOptions,
        options: __options
      });
    } else if (Array.isArray(apiData)) {
      options = []
      apiData.forEach((item) => {
        if (item[control.textfield] && item[control.valuefield]) {
          var arr = {}
          arr.label = item[control.textfield] ? item[control.textfield] : item["key"];
          arr.value = item[control.valuefield] ? item[control.valuefield] : item["value"];

          options.push(arr);
        }
      });
      this.setState({
        options: options
      });
    }
    var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {};
    this.controlVaildationCheck(this.props);
    this.setDefaultValue(control, options);
    this.updatePageVarible(control, data, data[control.key]);
  }
  updatePageVarible(control, _data, value) {
    if (control.islinkpagevarible) {
      var token = this.props.token;
      var menu = ControlService().deepcopy(token.menu);
      var currentUrl = window.location.pathname;
      if (currentUrl.indexOf('/forms/Edit') > -1) {
        currentUrl = "/forms/Edit";
      }
      ControlService().loop(menu['Nav'], currentUrl.substring(1), (item, index, arr) => {
        item.Params.forEach(_item => {
          if (_item.name === control.pagevariblelink && _item.value !== "&") {
            _item.value = value ? value : _data[_item.name];
          } else if (control.storeextranodes && Array.isArray(control.extranodes)) {
            var node = control.extranodes.find(x => x == _item.name);
            if (node) {
              _item.value = _data[node];
            }
          } else if (_item.attribute === control.pagevariblelink && _item.value !== "&") {
            _item.value = value ? value : _data[_item.attribute];
          }
        });
      });

      token.menu = menu;
      this.props.authSetToken(token);
    }
  }
  async setBindingwithothercontrols(control, props, isInitialize, bindingValue) {
    if (control.bindingwithothercontrols) {
      var apiRefrshCtrls = control.bindingwithothercontrols.filter(item => item.actiontype != "populate");
      if (control.allowbindingwithcontrols == true && apiRefrshCtrls.length > 0) {
        await ControlService().RefreshBindingControls(control.key, control.bindingwithothercontrols, props, isInitialize);
      }

      if (control.actiondatasource) {
        this.refreshBindingControlsFromApi(control, props, bindingValue);
      }
    }
  }
  refreshBindingControlsFromApi(control, props, bindingValue) {
    if (control.bindingwithothercontrols) {
      control.bindingwithothercontrols.forEach(_ctrl => {
        if (_ctrl.actiontype != "filter") {
          this.props.update(_ctrl.controlkey, '', props.formid);
        }
      });
    }
    // ...using get request
    var apiurl = "";
    apiurl = control.api;
    var data = props.data[props.formid] ? props.data[props.formid] : {};
    var apiparam = {};
    control.apiparam.forEach(option => {
      apiparam[option.key] = option.value;
    })
    if (control.bindingqueryfield) {
      apiparam[control.bindingqueryfield] = bindingValue ? bindingValue : data[control.key];
    }
    if (control.actionenablerowquery) {
      apiparam.query = control.actionrawquery;
    }
    let _control = ControlService().extractControl(control, 'action');
    _control.apitype = 'apiparam';
    this.props.dataIsLoading(true);
    ControlService().ServiceRequest(apiurl, apiparam, _control, props.token, data)
      .then((res) => {
        this.props.dataIsLoading(false);
        var dataOtption = [];
        if (control.actionresponsefield) {
          dataOtption = res ? res[control.actionresponsefield] : [];
        } else {
          dataOtption = res;
        }

        control.bindingwithothercontrols.forEach(ctrl => {
          if (ctrl.actiontype != "filter") {
            data = dataOtption[ctrl.bindingfield];

            if (ctrl.controltype == 'grid' && Array.isArray(data)) {
              data.map(item => {
                if (!item.id) {
                  item.id = uuidv4();
                }
                this.props.resetData(item, item.id + 'write');
              })
            }
            this.props.update(ctrl.controlkey, data, props.formid);

            _control = {};
            _control.type = ctrl.controltype;
            _control.key = ctrl.controlkey;
            var validation = ControlService().validate(_control, data);
            if (validation) {
              this.props.update(_control.key, { "status": "pass", "control": _control, touched: false }, props.formid + "_validation")
            } else {
              this.props.update(_control.key, { "status": "fail", "control": _control, touched: false }, props.formid + "_validation")
            }
          }
        });
        this.forceUpdate();
      })
      .catch(err => {
        this.props.dataIsLoading(false);
        console.log("refreshBindingControlsFromApi-Drodown")
      });
  }
  onValueChange(itemValue, control, action, isSetDefault = false) {
    var validation = ControlService().validate(control, itemValue ? itemValue.value : "");
    var formValidation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"] : {}
    debugger;
    var data;
    if (validation && (!formValidation[control.key] || formValidation[control.key].status != "pass")) {
      this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
    } else if (!validation && (!formValidation[control.key] || formValidation[control.key].status != "fail")) {
      this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
    }
    if (control.selectiontype !== 'multi' && control.type !== 'multiselect') {
      if (control.storejsonnode == true) {
        if (this.state.apiData.length > 0) {
          data = itemValue ? this.state.apiData.find(x => x[control.valuefield] == itemValue.value) : null;
          this.props.update(control.key + "_node", data, this.props.formid)
        }
      }
      data = itemValue ? itemValue.value : "";
      if (!data) {
        data = control.outputtype == "number" ? null : "";
      }
      this.storeExtraNodes(control, data);
      this.props.update(control.key, data, this.props.formid)
    } else {
      data = [];
      if (itemValue) {
        itemValue.map(item => {
          data.push(item.value);
        })
      }
      if (control.maximumselect > 0 && itemValue && itemValue.length > control.maximumselect) {
        this.setState({ maximumselect: true });
      } else {
        if (this.state.maximumselect) {
          this.setState({ maximumselect: false });
        }
        this.props.update(control.key, data, this.props.formid)
      }
    }
    if (isSetDefault || !control.actiondatasource) {
      var _data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {};
      if ((Array.isArray(_data[control.key]) && JSON.stringify(_data[control.key]) != JSON.stringify(data)) || (_data[control.key] != data)) {
        this.controlVaildationCheck(this.props);
        this.setBindingwithothercontrols(this.props.control, this.props, isSetDefault, data);
        this.updatePageVarible(this.props.control, _data, data);
      }
    }

    if (control.isLazyLoad || control.storetextfield) {
      this.props.update(control.textfield, itemValue ? itemValue.label : '', this.props.formid)
    }
    if (Array.isArray(control.resetcontrols) && control.resetcontrols.length > 0) {
      var Modeldata = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {};
      control.resetcontrols.map(item => {
        if (typeof Modeldata[item]) {
          switch (typeof Modeldata[item]) {
            case 'object':
              if (Array.isArray(Modeldata[item])) {
                Modeldata[item] = [];
              } else {
                Modeldata[item] = {};
              }
              break;
            case 'array':
              Modeldata[item] = [];
              break;
            case 'boolean':
              Modeldata[item] = false;
              break;
            case 'number':
              Modeldata[item] = null;
              break;
            default:
              Modeldata[item] = "null";
          }
          this.props.update(item, Modeldata[item], this.props.formid);
        }
      })
    }
  }
  storeExtraNodes(control, value) {
    if (control.storeextranodes && Array.isArray(control.extranodes)) {
      let data = value ? this.state.apiData.find(x => x[control.valuefield] == value) : null;
      control.extranodes.map(item => {
        this.props.update(item, data ? data[item] : null, this.props.formid);
      });
    }
  }

  controlVaildationCheck(props, isInitialize) {
    const { control, formid, data } = props;
    var _data = isInitialize ? null : data[formid] ? data[formid][control.key] : null
    var _dataValidation = data[formid + "_validation"] && data[formid + "_validation"][control.key] ? data[formid + "_validation"][control.key] : {}
    var validation = ControlService().validate(control, _data);
    if (validation) {
      if (_dataValidation.status != 'pass') {
        this.props.update(control.key, { "status": "pass", "control": control, touched: false }, this.props.formid + "_validation")
      }
    } else if (_dataValidation.status != 'fail') {
      this.props.update(control.key, { "status": "fail", "control": control, touched: false }, this.props.formid + "_validation")
    }
  }
  setDefaultValue(control, options) {
    var data = this.props.data[this.props.formid] ? this.props.data[this.props.formid] : {}
    if (Array.isArray(options) && options.length > 0) {
      var val = options ? options.find(x => x.value == data[control.key]) : null;
      if (control.autoselectfirstvalue == true) {
        if ((control.type !== 'multiselect' && control.selectiontype !== 'multi' && !val) ||
          ((control.type == 'multiselect' || control.selectiontype == 'multi') && Array.isArray(data[control.key]) && data[control.key].length == 0)) {
          var _val = options[0];
          this.onValueChange(_val, control, this.props.action, true);
        }
      } else if (control.defaultselectedvalue) {
        if ((control.type !== 'multiselect' && control.selectiontype !== 'multi' && !val) ||
          ((control.type == 'multiselect' || control.selectiontype == 'multi') && Array.isArray(data[control.key]) && data[control.key].length == 0)) {
          _val = options.find(x => x.value == control.defaultselectedvalue);
          if (_val) {
            this.onValueChange(_val, control, this.props.action, true);
          }
        }
      } else {
        this.controlVaildationCheck(this.props);
        this.setBindingwithothercontrols(control, this.props, true);
      }
    }
  }
  handleInputChange(newValue) {
    const { control } = this.props;
    if (control.type !== 'dropdown' && control.databind != "Client Data") {
      const inputValue = newValue.replace(/\W/g, '');
      this.setState({ inputValue: inputValue }, () => {
        if (newValue && newValue.trim() !== "") {
          this.ApiCall(this.state.parentctrdata);
        }
      });
    }
  }
  getDefaultMultiValue(value) {
    var defaultvalue = [];
    if (Array.isArray(value) && Array.isArray(this.state.options)) {
      value.forEach(item => {
        var option = this.state.options.find(x => x.value.toString() === item.toString());
        if (option) {
          defaultvalue.push(option);
        } else {
          option = { label: item, value: item };
          defaultvalue.push(option);
        }
      })
    }
    return defaultvalue;
  }
  getDefaultSingleValue(value) {
    var defaultValue = null;
    if (Array.isArray(this.state.options) && this.state.options.length > 0) {
      defaultValue = this.state.options.find(x => x.value == value);
      if (!defaultValue && value) {
        defaultValue = { label: value, value: value }
      } else if (!defaultValue) {
        defaultValue = null;
      }
    } else if (value) {
      defaultValue = { label: value, value: value }
    }
    return defaultValue;
  }
  handleBlur = () => {
    if (this.state.maximumselect) {
      this.setState({ maximumselect: false });
    }
    this.setState({
      touched: true,
    });
  }
  additemAction(control) {
    this.props.resetModelPopup(!this.props.isModelOpened);
    this.props.setModelFormId(control.additemformid);
    this.setState({
      isAdditemlinkClick: true
    })
  }
  shouldMarkError(control, data) {
    const validate = ControlService().validate(control, data[control.key]);

    const validation = this.props.data[this.props.formid + "_validation"] ? this.props.data[this.props.formid + "_validation"][control.key] : null;
    const isTouchedOutside = validation ? validation.touched : false;
    const shouldShow = this.state.touched || isTouchedOutside;
    return validate ? !validate : shouldShow;
  }
  render() {
    const { control, action, formid } = this.props;
    var data = this.props.data[formid] ? this.props.data[formid] : {}
    // this.setDefaultValue(control, data);
    const defaultValue = control.selectiontype !== 'multi' && control.type !== 'multiselect' ? this.getDefaultSingleValue(data[control.key]) : this.getDefaultMultiValue(data[control.key]);
    const shouldMarkError = this.shouldMarkError(control, data);
    if (action == 'filter') {
      return (
        <div className="form-group">
          {control.label &&
            <label htmlFor={control.id}>
              {control.label}
              {control.require &&
                <sup className="text-danger font-weight-bold">*</sup>
              }
              {control.showhelptext &&
                <span className={"custom-tooltip"}>
                  <i className={"fa fa-question-circle ml-2 help-text"}></i>
                  <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                </span>
              }
            </label>
          }
          <Select
            inputId={control.id}
            className={shouldMarkError ? "select-control error" : "select-control"}
            classNamePrefix="select"
            menuPortalTarget={document.body}
            menuPlacement="auto"
            styles={{ menuPortal: base => ({ ...base, zIndex: 999999 }) }}
            value={this.props.filterdata[control.key]}
            isClearable={control.selectiontype !== 'multi' ? true : false}
            isMulti={control.selectiontype !== 'multi' ? false : true}
            name={control.name}
            isSearchable={control.enablesearchfilter}
            placeholder={control.placeholder}
            noOptionsMessage={() => control.notFoundText ? control.notFoundText : 'No more options'}
            isLoading={this.state.isApiCalling}
            hideSelectedOptions={control.hideSelected}
            closeMenuOnSelect={control.closeOnSelect}
            options={this.state.options}
            onChange={(e) => this.onValueChange(e, control, action)}
            isDisabled={this.props.disabled}
            
          />
        </div>
      );
    } else {
      return (
        <div className="form-group">
          <div className={"d-flex"}>
            {control.additemlink && control.addbuttonposition == 'left' &&
              <div className="flex-grow-0 d-flex flex-column pr-2 align-self-end">
                {control.linktext && <label>{control.linktext}</label>}
                {control.imageurl && <img src={control.imageurl} width="20" height="20" alt={control.label} className="mb-2 img-fluid" />}
                <button aria-label={control.linktext ? control.linktext : control.linkname} className={"btn pointer btn-" + (control.buttontype) + (control.buttontype == 'link' ? " px-0" : '')} onClick={(e) => { e.preventDefault(); this.additemAction(control) }}>
                  {control.webnametype == 'icononly' || control.webnametype == 'nameicon' ? <i className={"fa-lg " + (control.WebIcon) + (control.webnametype == 'nameicon' ? ' mr-2' : '')}></i> : null}
                  {control.webnametype == 'nameicon' || control.webnametype == 'nameonly' ? <span>{control.linkname}</span> : null}
                </button>
              </div>
            }
            <div className="flex-grow-1">
              {control.label &&
                <label htmlFor={control.id}>
                  {control.label}
                  {control.require &&
                    <sup className="text-danger font-weight-bold">*</sup>
                  }
                  {control.showhelptext &&
                    <span className={"custom-tooltip"}>
                      <i className={"fa fa-question-circle ml-2 help-text"}></i>
                      <span className={"tooltip tooltip-" + control.helpdirection}>{control.help}</span>
                    </span>
                  }
                </label>
              }
              {
                control.groupby ?
                  <Select
                    inputId={control.id}
                    className={shouldMarkError ? "select-control error" : "select-control"}
                    classNamePrefix="select"
                    menuPortalTarget={document.body}
                    menuPlacement="auto"
                    styles={{ menuPortal: base => ({ ...base, zIndex: 999999 }) }}
                    value={defaultValue}
                    isClearable={control.selectiontype !== 'multi' ? true : false}
                    isMulti={control.selectiontype !== 'multi' ? false : true}
                    name={control.name}
                    isSearchable={control.enablesearchfilter}
                    placeholder={control.placeholder}
                    noOptionsMessage={() => control.notFoundText ? control.notFoundText : 'No more options'}
                    isLoading={this.state.isApiCalling}
                    hideSelectedOptions={control.hideSelected}
                    closeMenuOnSelect={control.closeOnSelect}
                    options={this.state.groupedOptions}
                    formatGroupLabel={_data => (
                      <div style={groupStyles}>
                        <span>{_data.label}</span>
                        <span style={groupBadgeStyles}>{_data.options.length}</span>
                      </div>
                    )}
                    onChange={(e) => this.onValueChange(e, control, action)}
                    onBlur={() => this.handleBlur()}
                    isDisabled={this.props.disabled}
                    
                  />
                  : control.isLazyLoad ?
                    <Select
                      inputId={control.id}
                      className={shouldMarkError ? "select-control error" : "select-control"}
                      classNamePrefix="select"
                      menuPortalTarget={document.body}
                      menuPlacement="auto"
                      styles={{ menuPortal: base => ({ ...base, zIndex: 999999 }) }}
                      value={defaultValue}
                      isClearable={control.selectiontype !== 'multi' ? true : false}
                      isMulti={control.selectiontype !== 'multi' ? false : true}
                      name={control.name}
                      isSearchable={control.enablesearchfilter}
                      placeholder={control.placeholder}
                      noOptionsMessage={() => control.notFoundText ? control.notFoundText : 'No more options'}
                      isLoading={this.state.isApiCalling}
                      hideSelectedOptions={control.hideSelected}
                      closeMenuOnSelect={control.closeOnSelect}
                      onInputChange={(e) => this.handleInputChange(e)}
                      onChange={(e) => this.onValueChange(e, control, action)}
                      options={this.state.options}
                      onBlur={() => this.handleBlur()}
                      isDisabled={this.props.disabled}
                      
                    />
                    : control.addTag || control.type == 'multiselect' || control.type == 'dropdown' ?
                      <CreatableSelect
                        inputId={control.id}
                        className={shouldMarkError ? "select-control error" : "select-control"}
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        styles={{ menuPortal: base => ({ ...base, zIndex: 999999 }) }}
                        classNamePrefix="select"
                        value={defaultValue}
                        isClearable={control.selectiontype !== 'multi' && control.type !== 'multiselect' ? true : false}
                        isMulti={control.selectiontype !== 'multi' && control.type !== 'multiselect' ? false : true}
                        name={control.name}
                        placeholder={control.placeholder}
                        noOptionsMessage={() => control.notFoundText ? control.notFoundText : 'No more options'}
                        isLoading={this.state.isApiCalling}
                        hideSelectedOptions={control.hideSelected}
                        closeMenuOnSelect={control.closeOnSelect}
                        onInputChange={(e) => this.handleInputChange(e)}
                        onChange={(e) => this.onValueChange(e, control, action)}
                        options={this.state.options}
                        onBlur={() => this.handleBlur()}
                        isDisabled={this.props.disabled}
                        
                      />
                      :
                      <Select
                        inputId={control.id}
                        className={shouldMarkError ? "select-control error" : "select-control"}
                        classNamePrefix="select"
                        menuPortalTarget={document.body}
                        menuPlacement="auto"
                        styles={{ menuPortal: base => ({ ...base, zIndex: 999999 }) }}
                        value={defaultValue}
                        isClearable={control.selectiontype !== 'multi' ? true : false}
                        isMulti={control.selectiontype !== 'multi' ? false : true}
                        name={control.name}
                        isSearchable={control.enablesearchfilter}
                        placeholder={control.placeholder}
                        noOptionsMessage={() => control.notFoundText ? control.notFoundText : 'No more options'}
                        isLoading={this.state.isApiCalling}
                        hideSelectedOptions={control.hideSelected}
                        closeMenuOnSelect={control.closeOnSelect}
                        options={this.state.options}
                        onChange={(e) => this.onValueChange(e, control, action)}
                        onBlur={() => this.handleBlur()}
                        isDisabled={this.props.disabled}
                        
                      />
              }
            </div>
            {control.additemlink && control.addbuttonposition == 'right' &&
              <div className="flex-grow-0 d-flex flex-column pl-2 align-self-end">
                {control.linktext && <label>{control.linktext}</label>}
                {control.imageurl && <img width="20" height="20" alt={control.label} src={control.imageurl} className="mb-2 img-fluid" />}
                <button aria-label={control.linktext ? control.linktext : control.linkname} className={"btn pointer btn-" + (control.buttontype) + (control.buttontype == 'link' ? " px-0" : '')} onClick={(e) => { e.preventDefault(); this.additemAction(control) }}>
                  {control.webnametype == 'icononly' || control.webnametype == 'nameicon' ? <i className={"fa-lg " + (control.WebIcon) + (control.webnametype == 'nameicon' ? ' mr-2' : '')}></i> : null}
                  {control.webnametype == 'nameicon' || control.webnametype == 'nameonly' ? <span>{control.linkname}</span> : null}
                </button>
              </div>
            }
          </div>
          {control.additemlink && control.addbuttonposition == 'bottom' &&
            <div className="d-flex align-items-center form-text">
              {control.linktext && <div className="pr-1">{control.linktext}</div>}
              {control.imageurl && <img width="20" height="20" alt={control.label} src={control.imageurl} className="mb-2 img-fluid" />}
              <button aria-label={control.linktext ? control.linktext : control.linkname} className={"btn pointer btn-" + (control.buttontype) + (control.buttontype == 'link' ? " px-0" : '')} onClick={(e) => { e.preventDefault(); this.additemAction(control) }}>
                {control.webnametype == 'icononly' || control.webnametype == 'nameicon' ? <i className={"fa-lg " + (control.WebIcon) + (control.webnametype == 'nameicon' ? ' mr-2' : '')}></i> : null}
                {control.webnametype == 'nameicon' || control.webnametype == 'nameonly' ? <span>{control.linkname}</span> : null}
              </button>
            </div>
          }
          {
            (shouldMarkError && (!defaultValue || (defaultValue && defaultValue.length == 0))) &&
            <small className="form-text text-danger">
              {control.errormsg ? control.errormsg : 'You must enter a ' + control.label + '.'}
            </small>
          }
          {
            data[control.key] && data[control.key].length < control.minimumselect && data[control.key].length > 0 ?
              <small className="form-text text-danger">Select Minimum {control.minimumselect} {control.label}</small>
              : null
          }
          {
            this.state.maximumselect && control.maximumselect && control.maximumselect > 0 && data[control.key].length > 0 ?
              <small className="form-text text-danger">You can select Maximum {control.maximumselect} {control.label}</small>
              : null
          }
          {
            control.charlimit && data[control.key] && data[control.key].length > control.charlimit ?
              <small className="form-text text-danger">
                You can enter Maximum {control.charlimit} characters.
              </small>
              : null
          }
        </div >
      );
    }
  }
}

export default connect(mapStateToProps, bindAction)(Dropdown);